export const COLORS = {
  YELLOW_PRIMARY: '#E5B611',
  YELLOW_LIGHT: '#F2DC39',
  YELLOW_HOVER: '#E4B131',
  YELLOW_LIGHT_HOVER: '#E6D232',

  PRIMARY: '#325A6D',
  PRIMARY_HOVER: '#2A4A5A',
  STEPPER_ACTIVE: '#325A6D',
  STEPPER_INACTIVE: '#B2B7C2',

  TEXT_DARK: '#191F2E',
  TEXT_MEDIUM: '#3F465A',
  TEXT_LIGHT: '#6E7585',

  BORDER_LIGHT: '#CACDD5',
  BORDER_HOVER: '#325A6D',
  DROPDOWN_BORDER: '#E5E7EB',

  BACKGROUND_LIGHT: '#FBFAFC',
  BACKGROUND_HOVER: 'white',

  ERROR: '#BE2929',
  SELECTED: '#1a73e8',
  SELECTED_TEXT: 'white',
} as const;

export const SIZES = {
  INPUT_HEIGHT: '40px',
  BORDER_RADIUS: '4px',
} as const;
